// extracted by mini-css-extract-plugin
export default {"root":"_30VP_","first-row":"Fq0or","firstRow":"Fq0or","second-row":"_2XP2J","secondRow":"_2XP2J"};